import { ProfessionalExperienceEntryType } from '../../../../Types/ProfessionalExperienceLineType';

export const schema: ProfessionalExperienceEntryType = {
	showMeOn: ['all'],
	length: '~4 years',
	timespan: '2014 -  2018',
	title: 'Founder & Chief Technology Officer',
	technologies: ['LAMP', 'Redis', 'NodeJS (Express)', 'SQL (OLTP)'],
	tools: ['AWS'],
	languages: ['Javascript', 'PHP', 'Java'],
	company: 'Bamba',
	description: 'A company that provided tools for data collection in emerging markets',
	location: 'Toronto, Ontario',
	results: 'Jan 2018 - Acquired by {Maximeyes Group,  https://maximeyesgroup.me}',
	details: [
		{
			showMeOn: ['all'],
			entry: 'Ensured high availability at 2,000 QPS by architecting a network stack that reliably supported 500k+ concurrent streams',
			// entry: 'Built architecture handling data streams from 500k+ users across multiple channels with peak of 2 000 QPS',
		},
		{
			showMeOn: ['all'],
			entry: 'Drove viral growth to 50k+ users (from 20) in 24 hours by designing a referral-reward system tuned for social sharing dynamics',
		},
		{
			showMeOn: ['all'],
			entry: 'Improved client autonomy by building a self-serve portal for designing, launching, and monitoring data collection campaigns',
		},
		{
			showMeOn: ['all'],
			entry: 'Drove cross-functional delivery for a 15-person team by owning end-to-end architecture, release execution, and coordination across Eng, QA, Product, and Ops',
		},
		{
			showMeOn: ['all'],
			entry: '\tImproved data integrity by 15% by developing real-time cleansing and fraud detection algorithms tuned to behavior anomalies',
		},
		{
			showMeOn: ['all'],
			entry: 'Attended TechStars, Austin (Winter 2016), absorbing mentorship and strategic guidance that fueled company growth',
		},
	],
};
